import React from 'react';

import FooterParticipant from '../../components/FooterParticipant';
import HeaderParticipant from '../../components/HeaderParticipant';
import styles from './styles.module.scss'

const FullPage = props => {
    return (
        <div id="wrapper">
            <div id="top">
                <HeaderParticipant />
            </div>
            <div className={styles.wrapper}>
                <div className={styles.content}>
                    {props.children}
                </div>
            </div>
            <FooterParticipant />
        </div>
    )
}

export default FullPage